import { createContext, useEffect, useState } from "react";
import {
  includes,
  assign,
  orderBy,
  get,
  fromPairs,
  uniqBy,
  sumBy,
  filter,
  sortBy,
  concat,
  find,
  sum,
  map,
} from "lodash";
import { loadStripe } from "@stripe/stripe-js/pure";

const WidgetContext = createContext({});

function gotoLocation(url) {
  window.top.location.href = url;
}

function mapContingent(contingent) {
    contingent.count = contingent.initial_count;
    return contingent;
}

function mapTicketing(ticketing) {
  ticketing.product_categories = [
    { name: "Alle Produkte", slug: "all" },
    ...(ticketing.product_categories || []),
  ];
  return ticketing;
}

const WidgetProvider = ({
  children,
  slug,
  loading,
  setLoading,
  step,
  setStep,
  ticketing_base_url,
}) => {
  const [contingents, setContingents] = useState([]);
  const [answers, setAnswers] = useState(null);
  const [ticketing, setTicketing] = useState(null);
  const [defaultCustomFieldsPerPurchase, setDefaultCustomFieldsPerPurchase] =
    useState([]);
  const [stripePublishableKey, setStripePublishableKey] = useState(null);
  const [automaticDiscountCodes, setAutomaticDiscountCodes] = useState([]);
  const [discountCodes, setDiscountCodes] = useState([]);

  useEffect(async () => {
    const resp = await fetch(
      `${ticketing_base_url}/tickets/api/${slug}/widget`
    );
    if (resp.status === 200) {
        const data = await resp.json();
      setContingents(data.contingents.map(mapContingent));
      setDefaultCustomFieldsPerPurchase(
        data.default_custom_fields_per_purchase
      );
      setAutomaticDiscountCodes(data.automatic_discount_codes);
      setStripePublishableKey(data.stripe_publishable_key);
      setTicketing(mapTicketing(data.ticketing));
      setAnswers(
        fromPairs(
          data.default_custom_fields_per_purchase.map((field) => [
            field.id,
            field.answer,
          ])
        )
      );
      setLoading(false);
    }
    // TODO: An error has occured, signal this somehow
  }, []);

  function startPaymentProcess(paymentMethod, additionPayload = {}) {
    // this.disableSubmitButton();
    // this.loading = true;
    // var self = this;

    // var seatsHoldToken = null;
    // if (this.seatingChart) {
    // 		seatsHoldToken = this.seatingChart.holdToken;
    // }

    var purchases = [];
    for (let contingent of contingents) {
      const count = contingent.count;
      if (count) {
        purchases.push({
          contingent: contingent,
          count: count,
          seats: contingent.seats,
          amount: count * contingent.price_gross,
          custom_answers: contingent.custom_answers,
          price: contingent.price_gross,
        });
      }
    }
    // Fix for duplicate contingent bug
    uniqBy(purchases, "contingent.id");

    var payload = {
      // convertFromPurchase: this.convertFromPurchase,
      // convertFromReservation: this.convertFromReservation,
      deliveryChannel: "email",
      // reservationId: this.reservationId,
      //				seatsHoldToken: seatsHoldToken,
      email: answers["email"],
      redirectToOrigin: true,
      discountCodes: discountCodes,
      buyerName: answers["buyerName"],
      paymentMethod: paymentMethod,
      purchases: orderBy(purchases, ["price"], ["desc"]), // Custom Field answers included
      custom_fields_per_purchase: map(answers, (answer, key) => ({
        id: key,
        answer: answer,
      })),
      // newsletterAccepted: this.newsletterOptin,
      // customTermsAccepted: this.customTermsAccepted
    };

    payload = assign({}, payload, additionPayload);

    //return fetch('/tickets/api/buy', { method: 'POST', body: JSON.stringify(payload), headers: {'Content-Type': 'application/json' } })

    return fetch(`${ticketing_base_url}/tickets/api/buy`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "X-CSRFToken": "{{csrf_token}}",
        "Content-Type": "application/json",
      },
    })
      .then(function (res) {
        self.paymentErrorStatus = res.status;
        return res.json();
      })
      .then(function (response) {
        if (response.url || response.stripe_session_id) {
          // TODO: Implement me
          // setRecentPurchase(response.token, payload.ticketCount, payload.buyerName);

          // //{% if cart_enabled %}
          // try {
          //     if (isSafari()) {
          // 	      SafeLocalStorage.removeItem('cart');
          //     }
          // } catch(e) {
          // }
          // //{% endif %}

          return response;
        }
        self.paymentError = get(response, "detail") || response;
        throw Error(response);
      });
  }

  function startPaymentProcessWithStripeCheckout(paymentMethod) {
    startPaymentProcess(paymentMethod).then(function (response) {
      var stripe_config = {};
      if (response.stripe_account_id) {
        stripe_config = {
          stripeAccount: response.stripe_account_id,
        };
      }
      loadStripe(stripePublishableKey, stripe_config).then((stripe) => {
        stripe
          .redirectToCheckout({
            // Make the id field from the Checkout Session creation API response
            // available to this file, so you can provide it as parameter here
            // instead of the {{CHECKOUT_SESSION_ID}} placeholder
            sessionId: response.stripe_session_id,
            //customerEmail: 'customer@example.com',
          })
          .then(function (result) {
            // If redirectToCheckout fails due to a browser or network
            // error, display the localized error message to your customer
            // using result.error.message.
            alert(result.error.message);
          });
      });
    });
  }

  function gotoPaymentProvider(paymentMethod) {
    // Tracker.pay(paymentMethod);
    switch (paymentMethod) {
      case "paypal":
      case "stripe_giropay":
      case "invoice":
        return startPaymentProcess(paymentMethod).then(function (response) {
          gotoLocation(response.url);
        });
        break;
      case "stripe_giropay":
      case "stripe_sofort":
      case "stripe_creditcard":
        return startPaymentProcessWithStripeCheckout(paymentMethod);
        break;
    }
  }

  return (
    <WidgetContext.Provider
      value={{
        loading,
        setLoading,
        contingents,
        setContingents,
        step,
        setStep,
        answers,
        setAnswers,
        ticketing,
        setTicketing,
        defaultCustomFieldsPerPurchase,
        setDefaultCustomFieldsPerPurchase,
        stripePublishableKey,
        setStripePublishableKey,
        automaticDiscountCodes,
        setAutomaticDiscountCodes,
        discountCodes,
        setDiscountCodes,
        gotoPaymentProvider,
        TICKETING_BASE_URL: ticketing_base_url,
      }}
    >
      {children}
    </WidgetContext.Provider>
  );
};

export { WidgetContext as default, WidgetProvider };
